import { Geolocation } from "@capacitor/geolocation";

const parseCachedLocation = () => {
	try {
		const cachedCurrentLocations = localStorage.getItem("currentLocations");
		if (cachedCurrentLocations) {
			const parsed = JSON.parse(cachedCurrentLocations);
			if (parsed?.coords) {
				return parsed;
			}
		}

		const cachedCurrentLocation = localStorage.getItem("currentLocation");
		if (cachedCurrentLocation) {
			const parsed = JSON.parse(cachedCurrentLocation);
			if (parsed?.coords) {
				return parsed;
			}
		}
	} catch (err) {
		console.warn("Unable to parse cached geolocation data:", err);
	}

	return null;
};

export default async function currentLocation() {
	const cachedLocation = parseCachedLocation();

	try {
		try {
			const permission = await Geolocation.checkPermissions();
			if (permission?.location === "prompt") {
				await Geolocation.requestPermissions();
			}
		} catch (permissionError) {
			// Continue and let getCurrentPosition handle permission errors consistently.
		}

		const coordinates = await Geolocation.getCurrentPosition({
			enableHighAccuracy: true,
			timeout: 10000,
			maximumAge: 30000,
		});

		if (coordinates?.coords) {
			const coordinatesJson = JSON.stringify(coordinates);
			localStorage.setItem("currentLocations", coordinatesJson);
			localStorage.setItem("currentLocation", coordinatesJson);
		}

		return coordinates;
	} catch (error) {
		const errorMessage = (
			error?.message ||
			error?.toString?.() ||
			""
		).toLowerCase();
		const isPermissionDenied =
			error?.code === 1 ||
			errorMessage.includes("denied") ||
			errorMessage.includes("permission");

		if (isPermissionDenied) {
			console.warn(
				"Geolocation permission denied. Allow location for localhost in your browser site settings.",
			);
			return cachedLocation || null;
		}

		console.error("Geolocation error:", error);
		return cachedLocation || null;
	}
}
